/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { capitalize } from '@veeam-vspc/shared/helpers';
import { colors as palette, useGlobalLang, useGlobalServices } from '@veeam-vspc/shared/components';

import type { VspcLang } from 'configs/languages';

import { BaseTrendChart } from '../../../BaseTrendChart';
import { TriggeredAlarmsService } from './services/triggered-alarms.service';

export const TriggeredAlarms: React.FC = () => {
    const lang = useGlobalLang<VspcLang>();
    const { transportService } = useGlobalServices();

    const params = {
        colors: [palette.R800, palette.Y450],
        yTitle: lang.ALARMS,
    };

    return (
        <BaseTrendChart
            params={params}
            service={new TriggeredAlarmsService(transportService, lang)}
            title={{ text: capitalize(lang.TRIGGERED_ALARMS) }}
        />
    );
};
